export default "https://cdn-static.gokick.com/assets/d05c895b658955f243e3d6e9c630166e56cf3faa/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";